import { getUserType } from "../TopUpBalance/components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { UserAccountInfo } from "../TopUpBalance/dependencies/getUserAccountInfo/UserAccountInfo";
import { EUserType } from "../constants";
export var getAccountType = function getAccountType() {
  var _UserAccountInfo$getI = UserAccountInfo.getInstance().getData(),
    accountNumber = _UserAccountInfo$getI.accountNumber;
  if (!accountNumber) return undefined;
  return getUserType(accountNumber) === EUserType.Mobile ? 'mobile' : 'fttb';
};